import './applicationProgressModal.scss';

import { ReactNode, useId } from 'react';
import { useTranslation } from 'react-i18next';

import { ProgressStep } from '../../store/progressStore/types/ProgressStep';
import { locator } from '../../testing/e2e-locator/locator';
import { Button } from '../Button/Button';
import { Dialog } from '../Dialog/Dialog';
import { CloseRoundedIcon } from '../Icons/CloseRoundedIcon';
import { Stepper } from '../Stepper/Stepper';

type ApplicationProgressModalProps = {
  progressSteps: ProgressStep[];
  onClose: () => void;
};

export const ApplicationProgressModal = ({
  progressSteps,
  onClose,
}: ApplicationProgressModalProps): ReactNode => {
  const { t } = useTranslation();
  const titleId = useId();

  return (
    <Dialog
      className="application-progress-modal"
      labelledBy={titleId}
      testId={locator.components.applicationProgressModal.root}
      onClose={onClose}
    >
      <header
        data-testid={locator.components.applicationProgressModal.header.root}
      >
        <h1
          data-testid={locator.components.applicationProgressModal.header.h1}
          id={titleId}
        >
          {t('applicationProgressModal.applicationProgress')}
        </h1>
        <button
          aria-label="Close progress"
          data-testid={
            locator.components.applicationProgressModal.header.closeButton
          }
          type="button"
          onClick={onClose}
        >
          <CloseRoundedIcon />
        </button>
      </header>
      <div>
        <main
          data-testid={locator.components.applicationProgressModal.main.root}
        >
          <Stepper
            steps={progressSteps}
            testId={locator.components.applicationProgressModal.main.stepper}
          />
        </main>
        <footer
          data-testid={locator.components.applicationProgressModal.footer.root}
        >
          <Button
            data-testid={
              locator.components.applicationProgressModal.footer.closeButton
            }
            fullWidth
            onClick={onClose}
          >
            {t('applicationProgressModal.close')}
          </Button>
        </footer>
      </div>
    </Dialog>
  );
};
